// Same public web config as the main site — access is governed by Firestore
// security rules, and the CMS additionally gates the UI to admins only.
export const firebaseConfig = {
  apiKey: "AIzaSyCyzMgLYlzUxQb3avZFcXbRqbsgciQ-7jE",
  authDomain: "rose-stroh-website.firebaseapp.com",
  projectId: "rose-stroh-website",
  storageBucket: "rose-stroh-website.firebasestorage.app",
  messagingSenderId: "1012064947330",
  appId: "1:1012064947330:web:5ceb8033e934d3fc59f89b",
  measurementId: "G-8JV66RY1K3",
};
